import { ReactWebComponent } from '@app/utils/web-components'
import { lazy } from 'react'

import type { UsageAlertAlertProps, UsageAlertType } from './UsageAlert'

const RootProviders = lazy(() => import('@app/components/AppProviders'))
const UsageAlert = lazy(() => import('./UsageAlert'))

class UsageAlertWebComponent extends ReactWebComponent {
	static get observedAttributes() {
		return ['alert-props', 'alert-type', 'team-uuid']
	}

	override render() {
		return (
			<RootProviders>
				<UsageAlert
					alertType={this.prop('alert-type') as UsageAlertType}
					alertProps={JSON.parse(this.prop('alert-props')) as UsageAlertAlertProps}
					teamUuid={this.prop('team-uuid')}
				/>
			</RootProviders>
		)
	}
}

customElements.define('usage-alert', UsageAlertWebComponent)
